import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { State } from '../../redux/root-reducer';
import { Nullable } from '../../shared-types';
import { WorkflowSideDrawer } from '../../workflow-navigation';
import { FormSubmissionState } from '../../workflow-navigation/reducers/fom-submission-reducer';
import { Workflow } from '../../workflow-navigation/reducers/workflow';
import { WorkflowScreen } from '../../workflow-navigation/reducers/workflow-screen';

interface Props {
    activeWorkflow: Workflow;
    activeScreen: Nullable<WorkflowScreen>;
    formSubmissionState: FormSubmissionState;
}

const claimStepsDrawer: React.FunctionComponent<Props> = ({
    activeWorkflow,
    activeScreen,
    formSubmissionState,
}: Props) => {
    const steps = !!activeWorkflow ? activeWorkflow.steps() : [];

    return (
        <WorkflowSideDrawer
            screens={steps}
            activeScreen={activeScreen}
            formSubmissionState={formSubmissionState}
        />
    );
};

const mapStateToProps = (state: State) => ({
    activeWorkflow: state.claimSession.workflow.activeWorkflow,
    activeScreen: state.claimSession.workflow.activeScreen,
    formSubmissionState: state.claimSession.formSubmission,
});

export const ClaimStepsDrawer = connect(mapStateToProps, {})(claimStepsDrawer);
